import VisaImage from "assets/visa.png"
import MastercardImage from "assets/mastercard.jpg"

export const cardBrand: { [key: string]: any } = {
  visa: VisaImage,
  mastercard: MastercardImage,
}
